export default __webpack_public_path__ + "static/media/grape.8cac96ad.jpg";